import { useCallback, useEffect, useState } from "react";
import { Plus, Search } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Pager, SelectField } from "@/lib/crm";
import { QUOTE_STATUS } from "@/lib/sales";
import { DemoBadge, PageHeader, Panel } from "@/components/common/ui-kit";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { QuoteRows } from "@/components/sales/QuoteRows";
import { NewQuoteDialog } from "@/components/sales/NewQuoteDialog";

export default function QuotesList() {
  const { can } = useAuth();
  const [f, setF] = useState({ q: "", status: "", page: 1 });
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  const set = (p) => setF((x) => ({ ...x, page: 1, ...p }));
  const load = useCallback(() => api.get("/sales/quotes", { params: Object.fromEntries(Object.entries(f).filter(([, v]) => v !== "")) })
    .then((r) => setData(r.data)).catch((e) => toast.error(errorMessage(e))), [f]);
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); }, [load]);

  return (
    <div data-testid="quotes-page">
      <PageHeader overline="Sales" title="Offerte" description="Proposte economiche collegate a cliente e opportunità, con revisioni tracciate."
        actions={can("quotes:create") && <Button onClick={() => setOpen(true)} className="gap-2" data-testid="quotes-new-button"><Plus />Nuova offerta</Button>} />
      <div className="mb-4 flex flex-col gap-2 sm:flex-row">
        <div className="relative flex-1"><Search className="absolute left-3 top-2.5 h-4 w-4 text-slate-400" />
          <Input className="pl-9" placeholder="Cerca per numero o oggetto…" value={f.q} onChange={(e) => set({ q: e.target.value })} data-testid="quotes-search" /></div>
        <SelectField value={f.status} onChange={(v) => set({ status: v })} options={Object.entries(QUOTE_STATUS).map(([key, v]) => ({ key, label: v.label }))} allowNone="Tutti gli stati" testId="quotes-filter-status" className="sm:w-56" />
      </div>
      <Panel className="px-5 py-2">{data && <QuoteRows quotes={data.items} empty="Nessuna offerta trovata." />}</Panel>
      {data && <Pager page={data.page} pages={data.pages} total={data.total} unit="offerte" onPage={(p) => setF((x) => ({ ...x, page: p }))} />}
      {data?.items.some((q) => q.is_demo) && <DemoBadge className="mt-3" />}
      <NewQuoteDialog open={open} onOpenChange={setOpen} />
    </div>
  );
}
